/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-assistant.reducer';

export const DiaglabAssistantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabAssistantEntity = useAppSelector(state => state.diaglabAssistant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabAssistantDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabAssistant.detail.title">DiaglabAssistant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.name">Name</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.email">Email</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.email}</dd>
          <dt>
            <span id="age">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.age">Age</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.age}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.gender}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.dateOfBirth}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.bloodGroup}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.education">Education</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.education}</dd>
          <dt>
            <span id="training">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.training">Training</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.training}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.experience}</dd>
          <dt>
            <span id="achievements">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.achievements">Achievements</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.achievements}</dd>
          <dt>
            <span id="labServiceType">
              <Translate contentKey="tinyMedicRestApp.diaglabAssistant.labServiceType">Lab Service Type</Translate>
            </span>
          </dt>
          <dd>{diaglabAssistantEntity.labServiceType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabAssistant.tmUser">Tm User</Translate>
          </dt>
          <dd>{diaglabAssistantEntity.tmUser ? diaglabAssistantEntity.tmUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabAssistant.contactCode">Contact Code</Translate>
          </dt>
          <dd>{diaglabAssistantEntity.contactCode ? diaglabAssistantEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabAssistant.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diaglabAssistantEntity.diagLab ? diaglabAssistantEntity.diagLab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-assistant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-assistant/${diaglabAssistantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabAssistantDetail;
